(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-game-live-info/assets/javascripts/casino-game-roulette-balls.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-game-live-info/assets/javascripts/casino-game-roulette-balls.js');

'use strict';

const listOfAvailableRouletteTypes = {
  doubleballroulette: true,
  qrol: true,
  rol: true,
  roulette: true
};
const rouletteBallColor = svs.components.casino_react.common.utils.rouletteBallColor;
const useCloudCasinoApis = svs.core.detect.feature('ft-use-casino-cloud-apis');
const CasinoGameRouletteBalls = _ref => {
  var _liveData$rouletteOut, _liveData$rouletteOut2;
  let liveData = _ref.liveData,
    liveCategory = _ref.liveCategory,
    liveResultType = _ref.liveResultType;
  if (!useCloudCasinoApis) {
    var _liveData$results, _liveData$results2;
    if (!(liveData !== null && liveData !== void 0 && (_liveData$results = liveData.results) !== null && _liveData$results !== void 0 && _liveData$results.length) || !listOfAvailableRouletteTypes[liveCategory] && liveResultType !== 'roulette' || liveData !== null && liveData !== void 0 && (_liveData$results2 = liveData.results) !== null && _liveData$results2 !== void 0 && _liveData$results2.every(item => item === null)) {
      return null;
    }
    return React.createElement("div", {
      className: "casino-game-card-live-results ".concat(liveCategory === 'doubleballroulette' ? 'casino-ball-double' : '')
    }, liveData.results.map((outcome, index) => React.createElement("span", {
      className: "casino-ball-outcome casino-ball-outcome--".concat(rouletteBallColor[outcome]),
      key: "ball-".concat(index, "-").concat(outcome)
    }, outcome)));
  }
  if (!(liveData !== null && liveData !== void 0 && (_liveData$rouletteOut = liveData.rouletteOutcomes) !== null && _liveData$rouletteOut !== void 0 && _liveData$rouletteOut.length) || !listOfAvailableRouletteTypes[liveCategory] && liveResultType !== 'roulette' || liveData !== null && liveData !== void 0 && (_liveData$rouletteOut2 = liveData.rouletteOutcomes) !== null && _liveData$rouletteOut2 !== void 0 && _liveData$rouletteOut2.every(item => item === null)) {
    return null;
  }
  return React.createElement("div", {
    className: "casino-game-card-live-results ".concat(liveCategory === 'doubleballroulette' ? 'casino-ball-double' : '')
  }, liveData.rouletteOutcomes.map((outcome, index) => React.createElement("span", {
    className: "casino-ball-outcome casino-ball-outcome--".concat(rouletteBallColor[outcome]),
    key: "ball-".concat(index, "-").concat(outcome)
  }, outcome)));
};
setGlobal('svs.components.casino_react.casino_game_live_info.CasinoGameRouletteBalls', CasinoGameRouletteBalls);

 })(window);